export const None = 0

export const CreateFile = 1

export const CreateFolder = 2

export const Rename = 3
